// extracted by mini-css-extract-plugin
export default {"root":"Sale_root__rUuA5","bigTitle":"Sale_bigTitle__-09wM","info":"Sale_info__WD6tS","subTitle":"Sale_subTitle__BVsJI","title":"Sale_title__+4aH8","logo":"Sale_logo__Oom9p"};